var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"input",attrs:{"value":_vm.formattedValue,"type":"text","label":_vm.label,"rules":_vm.rules,"suffix":_vm.suffix},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }